import { PagedSearch } from 'src/app/shared';

export class TransactionSearchDto extends PagedSearch {
  AdjustmentId: number;
  LineItemId: number;
  PaymentId: number;

  constructor(partialDto?: Partial<TransactionSearchDto>) {
    super();
    Object.assign(this, partialDto);
  }
}
